import { Directive, Input } from "@angular/core";
import { NzSkeletonElementDirective } from "ng-zorro-antd/skeleton";

@Directive({
  selector: "ui-skeleton-element",
  host: {
    "[class.ant-skeleton-active]": "nzActive",
  },
})
export class UiSkeletonElementDirective extends NzSkeletonElementDirective {
  @Input("uiActive") public nzActive = false;
  @Input("uiType") public nzType!: "button" | "input" | "avatar" | "image";
}
